import React, { useRef } from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { makeStyles } from '@material-ui/core/styles';

import SanitizedMarkdown from 'design-system/SanitizedMarkdown';
import FullstoryCheckModal from 'react-scale/components/scalers/tasks/textcollection/FullstoryCheckModal';
import NERWatermark from '../namedEntityRecognition/NERWatermark';

interface IProtectedTextAttachmentProps {
  text: string;
  loggedUserId?: string;
  renderAsPlainText?: boolean;
  disableLinksInTextAttachment?: boolean;
}

const useStyles = makeStyles({
  container: {},
  unselectable: {
    userSelect: 'none',
    zIndex: 100,
  },
  canvas: {
    width: '100%',
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 0,
  },
});

const ProtectedTextAttachment: React.FC<IProtectedTextAttachmentProps> = ({
  text,
  loggedUserId = 'workderID workerID',
  renderAsPlainText,
  disableLinksInTextAttachment,
}) => {
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} className={classes.container}>
      <div className={classes.unselectable}>
        <NERWatermark loggedUserId={loggedUserId} />
        {renderAsPlainText ? (
          (text as unknown as React.ReactNode)
        ) : (
          <SanitizedMarkdown
            text={text}
            disableLinksInTextAttachment={disableLinksInTextAttachment}
          />
        )}
      </div>
      <FullstoryCheckModal />
    </div>
  );
};

export default ProtectedTextAttachment;
